import script from "./Working-Hours.vue?vue&type=script&setup=true&lang=js"
export * from "./Working-Hours.vue?vue&type=script&setup=true&lang=js"

import "./Working-Hours.vue?vue&type=style&index=0&id=2e71c550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e71c550"]])

export default __exports__